import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownComponent } from './ngx-markdown.component';
import { MarkdownDirective } from './ngx-markdown.directive';
import { MarkedConfigClass, MarkdownService } from './ngx-markdown.service';
const NGXMARKDOWN_DECLARATIONS_EXPORTS = [MarkdownComponent, MarkdownDirective];
export class MarkdownModule {
    static forRoot(config) {
        return {
            ngModule: MarkdownModule,
            providers: [
                MarkdownService,
                { provide: MarkedConfigClass, useValue: config, multi: true }
            ]
        };
    }
    static forChild() {
        return {
            ngModule: MarkdownModule,
            providers: [
                MarkdownService,
                { provide: MarkedConfigClass, useClass: MarkedConfigClass, multi: true }
            ]
        };
    }
}
MarkdownModule.decorators = [
    { type: NgModule, args: [{
                declarations: NGXMARKDOWN_DECLARATIONS_EXPORTS,
                exports: NGXMARKDOWN_DECLARATIONS_EXPORTS,
                imports: [CommonModule]
            },] },
];
MarkdownModule.ctorParameters = () => [];
//# sourceMappingURL=ngx-markdown.module.js.map